import { Component } from '@angular/core';

@Component({
	selector: 'app-scrollable-text',
	templateUrl: './scrollable-text.component.html',
	styleUrls: ['./scrollable-text.component.scss']
})
export class ScrollableTextComponent {

	constructor() { }

}
